<style lang="scss" scoped>
.list {
  height: 100%;
  .item {
    color: #606266;
    border: 1px solid #dcdfe6;
    position: relative;
    text-align: left;
    cursor: pointer;
    padding-bottom: 10px;
    &.active {
      &::after {
        font-family: 'iconfont' !important;
        background: rgba($color: #000000, $alpha: 0.8);
        color: #fff;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        content: '\e607';
        font-size: 20px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
    .title {
      padding: 0 10px;
      box-sizing: border-box;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
    }
    .desc {
      padding: 8px;
      line-height: 19px;
    }
    .img {
      width: 100%;
      height: 160px;
    }
    &.multi {
      .first {
        position: relative;
        .title {
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0;
          color: #fff;
          background: rgba(0, 0, 0, 0.7);
        }
      }
      .other {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #dcdfe6;
        padding: 15px 0;
        &:last-child {
          border: none;
        }
        .title {
          font-size: 14px;
          line-height: 20px;
          height: 60px;
        }
        .img {
          flex-shrink: 0;
          margin-right: 10px;
          margin-left: 10px;
          width: 80px;
          height: 80px;
        }
      }
    }
  }
}
</style>

<template>
  <div>
    <div class="list">
      <Waterfall
        class="clearfix"
        :gutterHeight="30"
        :gutterWidth="30"
        :minCol="3"
        :resizable="true"
      >
        <WaterfallItem class="item multi" :width="300" v-for="item in list" :key="item.materialId">
          <template v-if="item.content.news.length>1">
            <div v-for="(item2,index) in item.content.news" :key="index">
              <template v-if="!index">
                <div class="first">
                  <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                  <div class="title line1">{{item2.title}}</div>
                </div>
              </template>
              <template v-else>
                <div class="other">
                  <div class="title line3">{{item2.title}}</div>
                  <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="title line1">{{item.content.news[0].title}}</div>
            <el-image :src="item.content.news[0].thumbUrl" lazy fit="cover" class="img"></el-image>
            <div class="desc">{{item.content.news[0].digest}}</div>
          </template>
        </WaterfallItem>
      </Waterfall>
      <div class="alignc">
        <el-pagination
          class="pager"
          layout="total, prev, pager, next, jumper"
          :page-size="pageSize"
          :current-page="page"
          :total="total"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { Waterfall, WaterfallItem } from 'vue2-waterfall';

export default {
  components: {
    Waterfall,
    WaterfallItem,
  },
  props: ['id'],
  computed: {},
  data() {
    return {
      page: 1,
      pageSize: 8,
      total: 0,
      list: [],
    };
  },
  methods: {
    async changePage(val) {
      this.page = val;
      await this.getData();
    },
    async getData() {
      let res = await this.$http.get(
        `/api/${this.id}/materials?page=${this.page}&size=${
          this.pageSize
        }&type=3`,
      );
      this.list = res.list;
      this.total = res.totalSize;
    },
  },
  async mounted() {
    let res = await this.$http.get(
      `/api/${this.id}/materials?page=${this.page}&size=${
        this.pageSize
      }&type=3`,
    );
    this.list = res.list;
    this.total = res.totalSize;
  },
};
</script>
